import {
  post
} from '../axios'

class Tmap {
  async suggestion(data,param) {
    const res = await post('/Tmap/Suggestion',data,param)
    return res
  }
    async geo(data,param) {
    const res = await post('/Tmap/Geo',data,param)
    return res
  }
}
export default new Tmap()